// extracted by mini-css-extract-plugin
export default {"app":"App_app__OOczz","color-input":"App_color-input__lB-yJ","hide-scrollbar":"App_hide-scrollbar__DVaGT"};